import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { useTranslation } from "react-i18next";

import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, IconButton, Typography } from '@mui/material';
import { Close, CheckCircle } from '@mui/icons-material';
import { Transition } from "./ControlUtils"
  
const Dialog4Alert = forwardRef((props, ref) => {
    const { t } = useTranslation();
    const resultActionMethod = React.useRef(null);

    const [messageObject, setMessageObject] = useState({
        Title: "",
        Content: "",
        IsOpen: false,
    });
    
    useImperativeHandle(ref, () => ({
        // 부모 컴포넌트에서 사용할 함수를 선언
        showMessageBox,
        showMessageBoxResult,
        setMessageObject
    }));

    const showMessageBox = (title, content) => {
        setMessageObject({
            Title: title,
            Content: content,
            IsOpen: true,
        });
    };

    const showMessageBoxResult = (title, content, actionMethod) => {
        setMessageObject({
            Title: title,
            Content: content,
            IsOpen: true,
        });
        resultActionMethod.current = actionMethod;
    };

    const closeMessageBox = () => {
        setMessageObject({
            Title: "",
            Content: "",
            IsOpen: false,
        });
    };

    const handleCloseDialog = () => {
        closeMessageBox();
        if(resultActionMethod.current) {
            resultActionMethod.current();
        }
        resultActionMethod.current = null;
    };
    

    return (
        <Dialog open={messageObject.IsOpen} TransitionComponent={Transition} maxWidth="sm" fullWidth 
                onClose={handleCloseDialog} 
                scroll="paper"
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
        >
            <DialogTitle>
                {messageObject.Title}
            </DialogTitle>
            <Box position="absolute" top={0} right={0}>
                <IconButton onClick={() => handleCloseDialog()}>
                    <Close />
                </IconButton>
            </Box>
            <DialogContent>
                <Typography>
                    {messageObject.Content}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => handleCloseDialog()} startIcon={<CheckCircle />} color="secondary" variant="contained">
                    {t('button.confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    );

});

export default Dialog4Alert;